import React from 'react';
import { Provider } from 'react-redux';
import { renderIntoContainer } from 'react/root/containerRoot';
import store from 'react/redux/store/store';
import ToastStack from 'react/notifications/ToastStack';

export const TOAST_ROOT_ID = 'notification_toasts';

// Mounts the achievement toasts once per page. The bell lives in the site
// header (react/layout/header/SiteHeader).
export default function mountNotifications(rootDocument = document) {
	const user = window.myUser;
	if(!user || !user.id) {
		return false;
	}
	let toastRoot = rootDocument.getElementById(TOAST_ROOT_ID);
	if(!toastRoot) {
		toastRoot = rootDocument.createElement('div');
		toastRoot.id = TOAST_ROOT_ID;
		rootDocument.body.appendChild(toastRoot);
	}
	renderIntoContainer(<Provider store={store}><ToastStack /></Provider>, toastRoot);
	return true;
}
